import styled from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  deepPurpleMui,
  greyMui,
  MOBILE_BREAKPOINT,
  rydeColors,
  ScreenDepth,
} from "@ryde/theme";

export const RidesPanelTopSettingsStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "rides-panel-top-settings",
})`
  width: 100%;
  height: 30px;
  padding-inline-start: 20px;
  padding-inline-end: 15px;
  padding-top: 20px;
  padding-bottom: 20px;
  margin-bottom: 2px;
  display: flex;
  align-items: center;

  .left_controls {
    display: flex;
    align-items: center;
    min-width: 0;
  }

  .right_stat_panel {
    margin-inline-start: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-shrink: 0;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    height: auto;
    min-height: 30px;
    flex-wrap: nowrap;
    gap: 4px;
    padding-inline: 8px;
    padding-block: 6px;

    .left_controls {
      flex: 1;
      min-width: 0;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }

    .right_stat_panel {
      flex-shrink: 0;
      margin-inline-start: auto;
    }

    .rides-view-switch {
      gap: 6px;
      margin-inline-start: 4px;
      margin-inline-end: 4px;
    }
  }
`;

export const RidesKanbanSortDropdownStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "rides-kanban-sort-dropdown",
  },
)`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-inline-end: 12px;

  .kanban_sort_button {
    position: relative;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-width: 44px;
    min-height: 32px;
    padding: 0 4px;
    border: none;
    border-radius: 4px;
    background: transparent;
    color: ${rydeColors.black};
    font: inherit;
    white-space: nowrap;
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid ${deepPurpleMui.A700};
      outline-offset: 1px;
    }

    /* Grows the click target to 44px high without changing the header row's height. */
    &::before {
      content: "";
      position: absolute;
      inset: -6px 0;
    }
  }

  /* The PRD asks for blueGrey 500, which is 4.4:1 on the white header; 600 keeps the look and passes AA. */
  .kanban_sort_value {
    color: ${blueGreyMui._600};
  }

  .kanban_sort_arrow {
    font-size: 20px;
  }
`;

export const RidesPanelTopWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "rides-panel-top-wrapper",
})`
  min-width: 100%;
  margin-bottom: 0;
  border-bottom: 1px solid ${greyMui._300};
  background-color: ${rydeColors.white};
`;

export const RideEditStatusDropdownStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "ride-edit-status-dropdown",
  },
)`
  position: relative;

  .edit_status_button {
    cursor: pointer;
    color: ${rydeColors.white};
    display: flex;
    align-items: center;
    gap: 5px;
    height: 32px;
    padding: 0px 8px;
    border-radius: 4px;
    border-inline-start: 2px solid ${rydeColors.venetianNights};
    background: ${rydeColors.purpleTitle};

    .edit_status_icon {
      display: flex;
    }

    .arrow_icon {
      padding-inline-start: 16px;
      position: relative;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .arrow_icon::before {
      content: "";
      position: absolute;
      inset-inline-start: 8px;
      top: 50%;
      transform: translateY(-50%);
      width: 1px;
      height: 100%;
      background: ${rydeColors.venetianNights};
    }
  }

  .edit_status_select {
    position: absolute;
    bottom: calc(100% + 5px);
    inset-inline-start: 0;
    display: inline-flex;
    padding: 10px;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 2px;
    border-radius: 5px;
    border: 1px solid ${greyMui._300};
    background-color: ${rydeColors.smoke};
    width: 100%;
    z-index: ${ScreenDepth.LANG_SWITCH_PANEL};
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);

    .option_item {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 35px;
      cursor: pointer;

      &:hover {
        transform: scale(1.07);
      }

      &.disabled {
        cursor: default;
        color: ${greyMui._500};
        pointer-events: none;
      }
    }
  }
`;
